import React from 'react'
import './Thankyou.css'
import ButtonArrow from './components/ButtonArrow'

class Thankyou extends React.Component {
     componentDidMount() {
    	this.timer = setTimeout(() => {
            window.location.href = '/'
    	}, 2000);
  	}

  	componentWillUnmount() {
    	clearTimeout(this.timer); // cleanup timer on unmount
  	} 

    render() {

    return (
        <div id="thankyou">
        <img id="thankyouimg" src="assets/img/illustrations/illustration-7.png" alt="thankyouimage"/>
        <div><p>Thank you</p><p>We will come back to you shortly</p></div>
        </div>
      
    )

    }
}

export default Thankyou
